import * as React from 'react';

import { Button } from '@mq/aurora-components/dist/button';

import * as styles from './category.css';

export class Category extends React.PureComponent<{}, {}> {
  handleDiscoverMarqueeRoute = () => {
    window.location.href = 'https://marquee.gs.com/s/discover';
  };

  handleContactHelpRoute = () => {
    const mailTo: string = 'gs-marquee-help@gs.com';
    const subject: string = 'Logging into Marquee';
    const body: string = 'I need assistance with logging into Marquee.';

    window.location.href = `mailto:${mailTo}?subject=${subject}&body=${body}`;
  };

  render() {
    return (
      <div className={styles.category}>
        <div className={styles.container}>
          <div className={styles.categoryCellStyle}>
            <h3>Learn More about Marquee</h3>
            <p>Discover the complete Marquee ecosystem of products and services.</p>
            <Button
              onClick={this.handleDiscoverMarqueeRoute}
              style={{ maxWidth: '180px', width: '100%' }}
            >
              Discover Marquee
            </Button>
          </div>
          <div className={styles.categoryCellStyle}>
            <h3>Need Assistance?</h3>
            <p>Forgot your password? Need help logging in?</p>
            <Button
              onClick={this.handleContactHelpRoute}
              style={{ maxWidth: '180px', width: '100%' }}
            >
              Contact Marquee Help
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
